// web-admin/src/components/StatCard.jsx
export default function StatCard({
  label,
  value,
  icon = "OP",
  tone = "default",
  meta = "",
}) {
  return (
    <div className={`dash-stat-card dash-stat-card--${tone}`}>
      <div className="dash-stat-card__top">
        <div className="dash-stat-card__icon">{icon}</div>
        <div className="dash-stat-card__label">{label}</div>
      </div>

      <div className="dash-stat-card__value">{value}</div>
      {meta ? <div className="dash-stat-card__meta">{meta}</div> : null}
    </div>
  );
}
